import { type AnimationOption } from "@package/ui-gql/index-data-access";
import { useEffect, useRef, useState, type ReactNode } from "react";
import { AnimationCardFade } from "./AnimatedCardFade";
import { AnimationCardFlip } from "./AnimatedCardFlip";
import { AnimationCardWipe } from "./AnimatedCardWipe";

type AnimatedTransitionCardProps = {
  animation: AnimationOption;
  node: ReactNode;
  nodeId: string;
};

export function AnimatedTransitionCard({
  animation,
  node,
  nodeId,
}: AnimatedTransitionCardProps) {
  const refCurrentNode = useRef<ReactNode>(undefined);
  const refCurrentNodeId = useRef<string | undefined>(undefined);

  const [nodeCurr, setNodeCurr] = useState<ReactNode>();
  const [nodePrev, setNodePrev] = useState<ReactNode>();
  const [reversed, setReversed] = useState<boolean>(false);

  useEffect(
    function effectOnNodeIdChanged() {
      if (refCurrentNodeId.current !== nodeId) {
        refCurrentNodeId.current = nodeId;
        refCurrentNode.current = node;

        setReversed((prev) => !prev);
      }
    },
    [node, nodeId],
  );

  useEffect(
    function effectOnCardFlipped() {
      if (reversed) {
        setNodePrev(refCurrentNode.current);
      } else {
        setNodeCurr(refCurrentNode.current);
      }
    },
    [reversed],
  );

  switch (animation.__typename) {
    case "AnimationOptionFade": {
      return (
        <AnimationCardFade
          animation={animation}
          nodeCurr={nodeCurr}
          nodePrev={nodePrev}
          reversed={reversed}
        />
      );
    }
    case "AnimationOptionFlip": {
      return (
        <AnimationCardFlip
          animation={animation}
          nodeCurr={nodeCurr}
          nodePrev={nodePrev}
          reversed={reversed}
        />
      );
    }
    case "AnimationOptionWipe": {
      return (
        <AnimationCardWipe
          animation={animation}
          nodeCurr={nodeCurr}
          nodePrev={nodePrev}
          reversed={reversed}
        />
      );
    }
    default: {
      return null;
    }
  }
}
